import { gql } from '@apollo/client';

export const CREATE_PERSONALIZED_CONTRACT_PREVIEW = gql`
  mutation Flex_CreatePersonalizedContractPreview($input: CreatePersonalizedContractPreviewInput!) {
    createPersonalizedContractPreview(input: $input) {
      base64
    }
  }
`;
